import { getFineUser } from './security.js'
let hasLoadedReport = false
export const createIframe = ({
  origin,
  loginPath,
  iframeId
},callback,user) => {
  return new Promise((resolve, reject) => {
    const { username, password } = getFineUser()
    const scr = document.createElement('iframe') // 创建iframe
    scr.id = iframeId
    const  queryUser = username  || user.username
    const queryPassword = password || user.password
    const enCodeUsername =  encodeURIComponent(queryUser)
    const enCodePassword = encodeURIComponent(queryPassword)
    const validity = `validity=-1`
    scr.src = `${origin}${loginPath}?fine_username=${enCodeUsername}&fine_password=${enCodePassword}&${validity}` // 省略callback参数 &callback=callback
    scr.onload = function (event) {
      const iframeLoad = localStorage.getItem(iframeId + '-hasload')
      if (!iframeLoad) { // 如果报表尚未加载
        scr.src = `${origin}/webroot/decision/view/report?op=write&viewlet=iframe.cpt`
        hasLoadedReport = true // 将标志变量设为true，表示报表已加载
        localStorage.setItem(iframeId + '-hasload',true)
        setTimeout(()=>{
          callback()
          resolve()
        },3000)
      }
    }
    // document.querySelector('.theme-container').appendChild(scr);
    document.getElementsByTagName("head")[0].appendChild(scr); 
  })
}


export const removeIframe = (iframeId = 'fineReportIframe') => {
  // 获取 iframe 的引用
  var iframe = document.getElementById(iframeId);
  // 检查 iframe 是否存在
  if (iframe) {
    // 从父元素中移除 iframe
    iframe.parentNode.removeChild(iframe);
  } 
}

export const findIframe = (iframeId = 'fineReportIframe') => {
  // 获取 iframe 的引用
  var iframe = document.getElementById(iframeId);
  // 检查 iframe 是否存在
  if (iframe) {
    // 从父元素中移除 iframe
    console.log('已有的iframe')
    return true
  } else {
    console.log('未找到指定的 iframe 元素');
    return false
  }
}
export const sendMessageToIframe = (msg, iframeId = 'fineReportIframe', origin,) => {
  const iframe = document.getElementById(iframeId).contentWindow
  const sendOrigin = window.location.origin; // 获取当前页面的域名
  console.log(msg,origin)
  iframe.postMessage(msg, origin)
}
